/**
 * Axios instance for HR backend. Sends Authorization: Bearer <token> on every request.
 * Token is stored in localStorage as "token" after HR login (POST /api/login).
 * baseURL is set at build time via REACT_APP_HR_API_URL (same origin as the app in production).
 */
import axios from 'axios';

const baseURL = process.env.REACT_APP_HR_API_URL || 'http://localhost:5001';
const hrApi = axios.create({ baseURL });

// Debug: in browser console you can run window.__HR_API_BASE__ to see what URL the app is using
if (typeof window !== 'undefined') window.__HR_API_BASE__ = baseURL;

hrApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

hrApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('token');
      const path = window.location.pathname || '';
      if (!path.includes('/login') && !path.includes('admin/login')) {
        sessionStorage.setItem('hr_login_redirect', '1');
        window.location.href = path.startsWith('/admin') ? '/admin/login' : '/login';
      }
    }
    return Promise.reject(err);
  }
);

export default hrApi;
